import { enviroment } from '@utils/config';
import io from 'socket.io-client';

function getSocket() {

  const { socketUrl } = enviroment;
  return io(socketUrl);

}

export default getSocket;
